// extracted by mini-css-extract-plugin
export var accordion = "accordion-modules--accordion--29ko5";
export var content = "accordion-modules--content--3ec5f";
export var button = "accordion-modules--button--3VTmt";
export var title = "accordion-modules--title--1PruM";